<!-- 検索スライドメニュー -->
<template>
  <transition
    name="searchSlideMenu"
    v-on:after-enter="afterEnter"
    v-on:after-leave="afterLeave"
  >
    <div v-if="showSearchMenu" class="crly-o-common-search-slide-menu"
      @touchmove.prevent=""
    >
      <div
        class="crly-o-common-search-slide-menu__close-area"
        @click="clickClose"
      >
        <div></div>
      </div>
      <div class="drawer-menu" @touchmove.stop="">
        <CrlyMoleculesCommonSearchKeyword />
        <CrlyMoleculesCommonSearchCategory
          :finishAnimation="finishAnimation"
          @clickLrgCat="clickClose"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import CrlyMoleculesCommonSearchKeyword from "@crly/components/molecules/common/search/keyword/Keyword.vue";
import CrlyMoleculesCommonSearchCategory from "@crly/components/molecules/common/search/category/Category.vue";

export default {
  name: "CrlyOrganismsCommonSearchSlideMenu",
  components: {
    CrlyMoleculesCommonSearchKeyword,
    CrlyMoleculesCommonSearchCategory
  },
  props: {
    showSearchMenu: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /**
       * 表示アニメーションが終了したかどうか
       */
      finishAnimation: false
    };
  },
  methods: {
    /**
     * 閉じるボタンクリックイベント
     */
    clickClose() {
      this.$store.commit("menuStatus/setCategoryMenu", false);
      this.$emit("clickMenusClose", false);
    },
    /**
     * 表示アニメーション完了時
     */
    afterEnter() {
      this.finishAnimation = true;
    },
    /**
     * 非表示処理完了後
     */
    afterLeave() {
      this.finishAnimation = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/common/searchSlideMenu.scss";
</style>
